import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { Modal } from '../Modal/Modal';
import { Level } from '../Modal/type';
import { useBreakpointFlag } from 'utils/hooks/useBreakpointFlag';
import { Container, Title } from './TemplateNameModal.styled';
import { useTranslation } from 'react-i18next';
import Input from 'components/Input/Input';
import Button from 'components/Button/Button';

export const TEMPLATE_NAME_MAX_LENGTH = 255;

export interface ITemplateNameModalProps {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  onSubmit: (name: string) => void;
  initialName?: string;
  isEdit?: boolean;
  isLoading?: boolean;
  level?: Level;
}

export const TemplateNameModal = ({
  isOpen,
  setIsOpen,
  onSubmit,
  initialName = '',
  isEdit = false,
  isLoading = false,
  level = 'SECOND',
}: ITemplateNameModalProps) => {
  const { t } = useTranslation();
  const { isSmallPhone } = useBreakpointFlag();
  const [name, setName] = useState<string>(initialName);

  useEffect(() => {
    if (isOpen) {
      setName(initialName);
    }
  }, [isOpen, initialName]);

  const trimmedName = name.trim();
  const isTooLong = name.length > TEMPLATE_NAME_MAX_LENGTH;
  const isSubmitDisabled = isLoading || !trimmedName || isTooLong;

  const handleSubmit = () => {
    if (isSubmitDisabled) {
      return;
    }
    onSubmit(trimmedName);
  };

  return (
    <Modal
      isOpen={isOpen}
      level={level}
      onClose={() => setIsOpen(false)}
      modalStyle={{
        margin: 'auto',
        width: isSmallPhone ? '90%' : '500rem',
        minWidth: isSmallPhone ? '90%' : 'auto',
        position: 'fixed',
      }}
    >
      <Container>
        <Title>{isEdit ? t('Rename template') : t('Name your template')}</Title>
        <Input
          placeholder={t('Template name')}
          width={'100%'}
          wrapperStyles={{ width: '100%' }}
          value={name}
          autoFocus
          onChange={(e) => setName(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              handleSubmit();
            }
          }}
          errorMessage={
            isTooLong ? t('Template name must not exceed 255 characters') : ''
          }
        />
        <Button
          label={isEdit ? t('Save') : t('Create')}
          primary
          width="100%"
          disabled={isSubmitDisabled}
          wrapperStyle={{ marginTop: '15rem', width: '50%' }}
          onClick={handleSubmit}
        />
      </Container>
    </Modal>
  );
};

export default TemplateNameModal;
